export const pageMessages: Record<string, string> = {
  'Sign out': '退出登录',
  'Sign Out': '退出登录',
  'Try Again': '重试',
  'Go home': '返回首页',
  'Go Home': '返回首页',
  'Unable to check your session. Please try again.': '无法检查登录状态，请重试。',
  'Welcome back!': '欢迎回来！',
  'Use your TOGA account across connected applications.': '使用 TOGA 账号登录已接入的应用。',
  'You are signed in as {email}': '当前登录账号：{email}',
  'Authorization Request': '授权请求',
  'Missing consent challenge': '缺少授权请求参数。',
  'Failed to load consent request. Please try again.': '无法加载授权请求，请重试。',
  'Failed to accept consent. Please try again.': '授权失败，请重试。',
  'Failed to reject consent. Please try again.': '无法拒绝授权，请重试。',
  'Authenticate you using OpenID Connect': '通过 OpenID Connect 验证你的身份',
  'Access your basic profile information': '访问你的基本个人资料',
  'Access your email address': '访问你的电子邮箱地址',
  'Access your account even when you are offline': '在你离线时继续访问你的账号',
  'Access scope: {scope}': '访问权限：{scope}',
  'Loading consent request...': '正在加载授权请求…',
  'An application': '某个应用',
  '{application} is requesting access to your account': '{application} 请求访问你的账号',
  '{application} logo': '{application} 的标志',
  'This application will be able to:': '此应用将能够：',
  'Processing...': '正在处理…',
  'Allow Access': '允许访问',
  'Deny': '拒绝',
  'Allow access only if you trust this application.': '请仅在信任此应用时允许访问。',
  'By allowing access, you agree to the': '允许访问即表示你同意',
  'Terms of Service': '服务条款',
  'Error': '错误',
  'Error: {code}': '错误：{code}',
  'Hint:': '提示：',
  'Loading error details...': '正在加载错误详情…',
  'An unexpected error occurred.': '发生了意外错误。',
  'Unable to complete authentication. Please try again.': '无法完成身份验证，请重试。',
  'The error details are no longer available. Please start again.': '错误详情已失效，请重新开始。',
  'The request is missing a required parameter or is otherwise malformed.': '请求缺少必填参数或格式有误。',
  'Client authentication failed.': '应用客户端身份验证失败。',
  'The provided authorization grant is invalid, expired, or revoked.': '提供的授权无效、已过期或已被撤销。',
  'The client is not authorized to request an authorization code.': '此应用客户端无权请求授权码。',
  'The authorization grant type is not supported.': '不支持此授权类型。',
  'The requested scope is invalid, unknown, or malformed.': '请求的权限范围无效、未知或格式有误。',
  'The resource owner or authorization server denied the request.': '账号所有者或授权服务器拒绝了此请求。',
  'The server encountered an unexpected condition.': '服务器发生了意外错误。',
  'The server is currently unable to handle the request.': '服务器暂时无法处理此请求。',
  'User authentication is required.': '请先登录。',
  'User consent is required.': '需要你确认授权。',
  'User interaction is required.': '需要你继续操作才能完成此请求。',
  'Your session has expired. Please try again.': '当前会话已过期，请重试。',
  'You are already signed in.': '你已登录。',
  'Additional authentication is required to continue.': '需要完成额外的身份验证才能继续。',
  'The security check failed. Please start again.': '安全检查失败，请重新开始。',
  'Unable to sign you out. Please try again.': '无法退出登录，请重试。',
  'Signing you out...': '正在退出登录…',
}
